import React, { useMemo } from 'react';
import { useTheme } from 'styled-components';

import { Spinner } from 'src/packages/core';
import {
  LeftIconWrapper,
  RightIconWrapper,
  StyledButton,
  TextWrapper,
  getStyles,
} from './Button.styles';
import { ButtonProps } from './Button.types';
import { LightTheme, DarkTheme } from 'src/packages/theme';

const Button: React.FC<ButtonProps> = (props) => {
  const {
    variant = 'brandDefault',
    text,
    isLoading = false,
    leftIcon,
    rightIcon,
    onClick = () => undefined,
    theme,
    ...rest
  } = props;

  const contextTheme = useTheme();

  const defaultTheme = useMemo(() => {
    return theme
      ? theme === 'dark'
        ? { ...DarkTheme, rtl: contextTheme.rtl }
        : { ...LightTheme, rtl: contextTheme.rtl }
      : contextTheme;
  }, [contextTheme, theme]);

  const styles = useMemo(() => {
    return getStyles(variant, defaultTheme);
  }, [variant, defaultTheme]);

  const internalOnClick = () => {
    if (!isLoading) {
      onClick();
    }
  };

  return (
    <StyledButton {...rest} styles={styles} onClick={internalOnClick}>
      {isLoading && <Spinner inline={true} size={24} color={defaultTheme.colors.text.primary} />}

      {leftIcon && !isLoading && (
        <LeftIconWrapper iconSize={styles.iconSize} hasMargin={!!text}>
          {leftIcon}
        </LeftIconWrapper>
      )}

      {!isLoading && text && <TextWrapper>{text}</TextWrapper>}

      {rightIcon && !isLoading && (
        <RightIconWrapper iconSize={styles.iconSize} hasMargin={!!text}>
          {rightIcon}
        </RightIconWrapper>
      )}
    </StyledButton>
  );
};

export default Button;
